import React, { PropsWithChildren, Ref } from 'react';

import { Icon } from '@/stories/atoms/Icon/Icon';
import { Hx } from '@/stories/atoms/Hx/Hx';
import advanced from './advanced-filters.module.css'

export type AdvancedFiltersProps = {
  ref: Ref<HTMLDialogElement>,
  onClose: () => void,
  actions: React.ReactNode,
  title: string
} & PropsWithChildren

export const FiltersDialog = ({ref, onClose, title, children, actions, ...props}: AdvancedFiltersProps) => {
  return (
    <dialog ref={ref} className={advanced.dialog} onCancel={onClose} {...props} id='advanced-panel'>
      <div className={advanced.wrapper}>
        <div className={advanced.head}>
          <Hx headingLevel='span' styleLevel='h4'>{title}</Hx>
          <button type='button' onClick={onClose} className={advanced.close}><span className='sr-only'>Fermer la modale</span><Icon icon='close' size={'xl'}/></button>
        </div>
        <div className={advanced.contentWpr}>
          <div className={advanced.content}>
            {children}
          </div>
        </div>
        <div className={advanced.actions}>
          {actions}
        </div>
      </div>
    </dialog>
  )
}
